import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTerceroForm } from '../Validations/ValidationsTercero';

export default function EditTerceroForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    tipoDocumento: '',
    documento: '',
    codigoPostal: '',
    provincia: '',
    pais: '',
    domicilio: '',
    telefono: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [serverError, setServerError] = useState('');

  useEffect(() => {
    const fetchTercero = async () => {
      try {
        const response = await axios.get(`/terceros/${id}`);
        setFormData(response.data);
      } catch (err) {
        setServerError('Error al cargar los datos del tercero.');
        console.error('Error fetching tercero:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTercero();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    const validationErrors = await validateTerceroForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        await axios.put(`/terceros/${id}`, formData);
        navigate('/home/terceros');
      } catch (err) {
        console.error('Error updating tercero:', err);
        setServerError(err.response?.data?.message || 'Error al actualizar el tercero. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  if (isLoading) return <div className="text-center mt-8">Cargando...</div>;

  return (
    <div className="max-w-2xl mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Editar Tercero</h2>
      {serverError && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">{serverError}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Nombre</label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.nombre ? 'border-red-500' : ''}`}
            required
          />
          {errors.nombre && <p className="text-red-500 text-xs italic">{errors.nombre}</p>}
        </div>
        <div>
          <label className="block mb-1">Tipo de Documento</label>
          <select
            name="tipoDocumento"
            value={formData.tipoDocumento}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.tipoDocumento ? 'border-red-500' : ''}`}
            required
          >
            <option value="">Seleccione tipo de documento</option>
            <option value="NIF">NIF</option>
            <option value="NIE">NIE</option>
            <option value="CIF">CIF</option>
            <option value="CIF Admin">CIF Admin</option>
          </select>
          {errors.tipoDocumento && <p className="text-red-500 text-xs italic">{errors.tipoDocumento}</p>}
        </div>
        <div>
          <label className="block mb-1">Documento</label>
          <input
            type="text"
            name="documento"
            value={formData.documento}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.documento ? 'border-red-500' : ''}`}
            required
          />
          {errors.documento && <p className="text-red-500 text-xs italic">{errors.documento}</p>}
        </div>
        <div>
          <label className="block mb-1">Código Postal</label>
          <input
            type="text"
            name="codigoPostal"
            value={formData.codigoPostal}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.codigoPostal ? 'border-red-500' : ''}`}
            required
          />
          {errors.codigoPostal && <p className="text-red-500 text-xs italic">{errors.codigoPostal}</p>}
        </div>
        <div>
          <label className="block mb-1">Provincia</label>
          <input
            type="text"
            name="provincia"
            value={formData.provincia}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.provincia ? 'border-red-500' : ''}`}
            required
          />
          {errors.provincia && <p className="text-red-500 text-xs italic">{errors.provincia}</p>}
        </div>
        <div>
          <label className="block mb-1">País</label>
          <input
            type="text"
            name="pais"
            value={formData.pais}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.pais ? 'border-red-500' : ''}`}
            required
          />
          {errors.pais && <p className="text-red-500 text-xs italic">{errors.pais}</p>}
        </div>
        <div>
          <label className="block mb-1">Domicilio</label>
          <input
            type="text"
            name="domicilio"
            value={formData.domicilio}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.domicilio ? 'border-red-500' : ''}`}
            required
          />
          {errors.domicilio && <p className="text-red-500 text-xs italic">{errors.domicilio}</p>}
        </div>
        <div>
          <label className="block mb-1">Teléfono</label>
          <input
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.telefono ? 'border-red-500' : ''}`}
            required
          />
          {errors.telefono && <p className="text-red-500 text-xs italic">{errors.telefono}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar Tercero'}
        </button>
      </form>
    </div>
  );
}